// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` #column2 {
    max-width: 100% !important;
    width: 100% !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/component/custom-error-page/custom-error-page.component.css"],"names":[],"mappings":"CAAC;IACG,0BAA0B;IAC1B,sBAAsB;AAC1B","sourcesContent":[" #column2 {\n    max-width: 100% !important;\n    width: 100% !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
